// 探针指纹工具(共享) —— doc/008、doc/009:「先测后存」的指纹与时间格式化。
// 被测对象任一字段变化,指纹即变化,之前通过的结果自动失效(主动态派生,无需逐字段重置)。

export function probeKey(...parts: Array<string | number>): string {
  return parts.join("|");
}

export function probeTime(iso: string): string {
  return new Date(iso).toLocaleTimeString();
}